// extracted by mini-css-extract-plugin
module.exports = {"video":"VideoRender_video___ghYx"};